import { render, staticRenderFns } from "./App.vue?vue&type=template&id=65fdc814&"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/.pnpm/registry.npmjs.org/vue-loader/15.8.3_da6d4e9e2eb855f7cee50b4ad4305dd2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports